import React from "react";

import { templates } from "@reactivated";

import { PageSkeleton } from "../components/PageSkeleton";

export const Template = (props: templates.HeaderPreviewTemplate) => (
    <PageSkeleton
        title="Header Preview"
        language={null}
        alternate_pages={[]}
        headerOverride={props.model}
    >
        <></>
    </PageSkeleton>
);
